import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import DangerousInnerHTML from 'portal-modules/common/components/DangerousInnerHTML'
import EmptyResult from 'portal-modules/common/components/EmptyResult'
import { RpModal } from 'portal-modules/common/components/modals'
import { Form } from '@entrata/portals-common/lib/components/forms'
import { RoundedCheckBox } from 'portal-modules/common/components/checkbox'
import { PageLoader } from 'portal-modules/common/components/loaders'
import { getDocumentsWithSettings } from '../../api/api'
import { connect } from 'react-redux'

import styled from '@emotion/styled'
import { css } from '@emotion/core'

const StyledForm = styled(Form)`
  font-size: 13px;

  @media screen and (min-width: 768px) {
    font-size: 16px;
  }

  > div:first-child {
    border-bottom: ${({ theme }) => `2px solid ${theme.gray.light}`};
    padding-bottom: 16px;
  }

  label {
    font-size: inherit;
    color: ${({ theme }) => `${theme.gray.mediumlight}`};
    font-size: 13px;
    font-weight: 400;
  }
  > div.action-wrapper {
    text-align: center;
    > button {
      margin-right: 0;
    }
  }
`

const StyledTnCWrapper = styled('p')`
  height: 320px;
  margin: 16px 0;
  overflow: auto;
  @media screen and (max-width: 1024px) {
    height: 21vh;
  }
`

const btnStyles = css`
  @media screen and (min-width: 768px) {
    width: 100%;
  }
`

const StyledCancelButton = styled(Button)`
  background-color: transparent;
  box-shadow: none;
  ${btnStyles};
`

const initialFieldState = {
  tncAgreement: { required: true },
}

class ESignTerms extends Component {
  state = {
    error: '',
    loading: true,
    terms: '',
  }

  componentDidMount() {
    if (!this.state.terms && !this.props.terms) {
      this.fetchTerms()
    } else {
      this.setState({ terms: this.props.terms, loading: false })
    }
  }

  fetchTerms = async () => {
    const { terms, languagePreference } = this.props
    if (terms) {
      this.setState({ terms: terms, loading: false })
    } else {
      try {
        const { settings } = await getDocumentsWithSettings({
          language_preference: languagePreference,
        })
        this.setState({ terms: settings.electronic_terms, loading: false })
      } catch (err) {
        console.error(err)
        this.setState({
          error: __('There was a problem loading the content.'),
          loading: false,
        })
      }
    }
  }

  render() {
    const { onSign, ...props } = this.props
    const { error, loading, terms } = this.state
    return (
      <RpModal
        title={__('eSign Terms & Conditions')}
        {...props}
        outsideContent={
          <StyledCancelButton
            appearance='action'
            isNormalButton
            onClick={props.onClose}
          >
            {__('Cancel')}
          </StyledCancelButton>
        }
      >
        <StyledForm initialFieldState={initialFieldState} onSubmit={onSign}>
          <Form.Field name='tncAgreement'>
            {props => (
              <RoundedCheckBox
                {...props}
                label={__(
                  'I agree to the following terms & conditions for using esign.',
                )}
              />
            )}
          </Form.Field>
          <StyledTnCWrapper tabIndex='0'>
            {!!terms && <DangerousInnerHTML>{terms}</DangerousInnerHTML>}
            {!!error && <EmptyResult>{error}</EmptyResult>}
            <PageLoader show={loading} />
          </StyledTnCWrapper>
          <Form.Actions>
            {() => (
              <div className='action-wrapper'>
                <Button appearance='primary' size='large' type='submit'>
                  {__('Start Signing Process')}
                </Button>
              </div>
            )}
          </Form.Actions>
        </StyledForm>
      </RpModal>
    )
  }
}

ESignTerms.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSign: PropTypes.func.isRequired,
  terms: PropTypes.string,
  languagePreference: PropTypes.string,
}

export default connect(({ accountSettings }) => ({
  languagePreference: accountSettings.language_preference || '',
}))(ESignTerms)
